import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PROGRAM_ORDER_BUNDLE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_PROGRAM_ORDER_BUNDLE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PROGRAM_ORDER_BUNDLE_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/program-orders/bundle`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
